/* eslint-disable jsx-a11y/anchor-is-valid */
import { PropTypes } from 'prop-types';
import React from 'react';
import styles from './index.module.scss';

const { badge, homeButton, inline, slim } = styles;

const AccionaBigButton = ({
  onClick,
  msg,
  icon,
  pendingDocs,
  id,
  disable,
  display,
  size,
}) => (
  <div
    className={`home-button ${icon} ${homeButton} ${
      disable ? 'disabled' : ''
    } ${display === 'inline' ? inline : ''} ${size === 'slim' ? slim : ''}`}
    id={id}
    onClick={onClick}
  >
    <a className="home-button" id="AccionaBigUploadButton">
      <div className="image-btn"> </div>
      <span> {msg}</span>
      {pendingDocs ? <span className={badge}>{pendingDocs}</span> : null}
    </a>
  </div>
);

AccionaBigButton.propTypes = {
  msg: PropTypes.string,
  id: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  pendingDocs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disable: PropTypes.bool,
  display: PropTypes.oneOf(['inline', 'block']),
  size: PropTypes.oneOf(['slim', 'normal']),
};

AccionaBigButton.defaultProps = {
  msg: 'UPLOAD',
  icon: 'data',
  id: undefined,
  pendingDocs: undefined,
  disable: false,
  display: 'block',
  size: 'normal',
};

export default AccionaBigButton;
